module.exports = __webpack_public_path__ + "img/logo-beatup.611e3922.png";